import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/jobSitePurchaseOrderActions'
import * as api from '../../api/job/jobSitePurchaseOrders'

function* jobSitePurchaseOrdersRefresh(action) {
  try {
    const payload = yield call(api.getJobSitePurchaseOrders, action.jobId)
    yield put({ type: constants.JOB_SITE_PURCHASE_ORDERS_REFRESH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_PURCHASE_ORDERS_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchJobSitePurchaseOrders() {
  yield takeLatest(constants.JOB_SITE_PURCHASE_ORDERS_REFRESH.ACTION, jobSitePurchaseOrdersRefresh)
}

function* getPurchaseOrderByOrganizationId(action) {
  try {
    const purchaseOrders = yield call(api.getPurchaseOrderByOrganizationId, action.organizationId)
    yield put({ type: constants.GET_PURCHASE_ORDERS_BY_ORGANIZATION_ID.SUCCESS, purchaseOrders })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_PURCHASE_ORDERS_BY_ORGANIZATION_ID.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetPurchaseOrderByOrganizationId() {
  yield takeLatest(
    constants.GET_PURCHASE_ORDERS_BY_ORGANIZATION_ID.ACTION,
    getPurchaseOrderByOrganizationId
  )
}

function* sagaCreateJobSitePurchaseOrder(action) {
  try {
    const payload = {
      job_id: action.jobId,
      description: action.description,
      files: action.files,
      created_by_id: action.userId,
      updated_by_id: action.userId
    }
    yield call(api.createJobSitePurchaseOrder, payload)
    yield put({ type: constants.JOB_SITE_PURCHASE_ORDER_CREATE.SUCCESS, payload })
    yield call(jobSitePurchaseOrdersRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_PURCHASE_ORDER_CREATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateJobSitePurchaseOrder() {
  yield takeLatest(constants.JOB_SITE_PURCHASE_ORDER_CREATE.ACTION, sagaCreateJobSitePurchaseOrder)
}

function* sagaUpdateJobSitePurchaseOrder(action) {
  try {
    const payload = {
      job_id: action.jobId,
      attachment_id: action.attachmentId,
      description: action.description,
      updated_by_id: action.userId,
      user_id: 1,
      files: action.files
    }
    yield call(api.updateJobSitePurchaseOrder, payload)
    yield put({ type: constants.JOB_SITE_PURCHASE_ORDER_UPDATE.SUCCESS, payload })
    yield call(jobSitePurchaseOrdersRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_PURCHASE_ORDER_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateJobSitePurchaseOrder() {
  yield takeLatest(constants.JOB_SITE_PURCHASE_ORDER_UPDATE.ACTION, sagaUpdateJobSitePurchaseOrder)
}

function* sagaDeleteJobSitePurchaseOrder(action) {
  try {
    const payload = {
      attachment_id: action.attachmentId
    }
    yield call(api.deleteJobSitePurchaseOrder, payload)
    yield put({ type: constants.JOB_SITE_PURCHASE_ORDER_DELETE.SUCCESS, payload })
    yield call(jobSitePurchaseOrdersRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_PURCHASE_ORDER_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteJobSitePurchaseOrder() {
  yield takeLatest(constants.JOB_SITE_PURCHASE_ORDER_DELETE.ACTION, sagaDeleteJobSitePurchaseOrder)
}

export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchJobSitePurchaseOrders),

    fork(watchCreateJobSitePurchaseOrder),
    fork(watchUpdateJobSitePurchaseOrder),
    fork(watchDeleteJobSitePurchaseOrder),

    fork(watchGetPurchaseOrderByOrganizationId)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/jobSitePurchaseOrderSaga.js